import {
  TabPane,
  Tab,
  MenuItem,
  Radio,
  FormDropdown,
  Form,
} from "semantic-ui-react";
import { useState } from "react";
import { SettingsCache } from "../cache/SettingsCache";
import { getSession, useMutationWrapper, useQueryWrapper } from "../helper";
import { SET_DEFAULT_PRIORITY, UPDATE_SETTINGS } from "../routes/mutations";
import { Tooltip } from "../tooltip";
import { GET_DEFAULT_PRIORITY } from "../routes/queries";
import { getPriorityDropdowns } from "../priority/priority";
import { NewHardcodedPageComponent } from "../components/page/NewHardcodedPageComponent";

export const SettingsTab = (props: {
  updateSettingsCallback: (show_tooltips: boolean) => void;
}) => {
  const [showTooltips, setShowTooltips] = useState(
    SettingsCache.getInstance().getShowTooltips(),
  );
  const [updateSettingsMutation] = useMutationWrapper(
    UPDATE_SETTINGS,
    (data) => {
      setShowTooltips(
        SettingsCache.getInstance().setShowTooltips(data.updateSettings),
      );
      props.updateSettingsCallback(data.updateSettings);
    },
  );
  const [defaultPriority, setDefaultPriority] = useState(3);
  const [setDefaultPriorityMutation] = useMutationWrapper(
    SET_DEFAULT_PRIORITY,
    (data) => {
      setDefaultPriority(data.setDefaultPriority);
      SettingsCache.getInstance().setDefaultPriority(data.setDefaultPriority);
    },
  );

  useQueryWrapper(GET_DEFAULT_PRIORITY, { session: getSession() }, (data) => {
    setDefaultPriority(data.getDefaultPriority);
  });

  const onShowTooltipsChange = (event: any, data: any) => {
    updateSettingsMutation({
      variables: { session: getSession(), show_tooltips: data.checked },
    });
  };

  return (
    <div>
      Show Tooltips:{" "}
      <Radio
        id="show-tooltips-checkbox"
        toggle
        checked={showTooltips}
        onChange={onShowTooltipsChange}
        onClick={onShowTooltipsChange}
      />
      <Form>
        <FormDropdown
          label="Default Priority"
          fluid
          selection
          value={defaultPriority}
          options={getPriorityDropdowns()}
          onChange={(event, data) => {
            setDefaultPriorityMutation({
              variables: {
                default_priority: data.value,
                session: getSession(),
              },
            });
          }}
        ></FormDropdown>
      </Form>
    </div>
  );
};

export const SettingsPage = (props: {
  updateSettingsCallback: (show_tooltips: boolean) => void;
}) => {
  const panes = [
    {
      menuItem: (
        <MenuItem>
          Settings
          <Tooltip
            name="Settings"
            message="Advanced control of your Second Brain"
          />
        </MenuItem>
      ),
      render: () => (
        <TabPane attached={false}>
          <NewHardcodedPageComponent
            props={{
              type: "hardcoded_page",
              page: (
                <SettingsTab
                  updateSettingsCallback={props.updateSettingsCallback}
                />
              ),
            }}
          />
        </TabPane>
      ),
    },
  ];

  return (
    <div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
};
